// extracted by mini-css-extract-plugin
export default {"dotsWrapper":"Carousel_dotsWrapper__UUbjI","end":"Carousel_end__WcAmY","dot":"Carousel_dot__681wU","active":"Carousel_active__DkAU7"};